import { useAppStoreSelector } from 'store';

export default function useAuth() {
  const authed = useAppStoreSelector((state) => state.authed);
  const login = useAppStoreSelector((state) => state.login);
  const logout = useAppStoreSelector((state) => state.logout);
  return { authed, login, logout };
}
